import { AuthWithHeaders } from 'types'
import * as Actions from 'redux/actions'
import store from 'redux/store'
import { RootState } from 'types'

export const UserService = {
  setAuthCookie: (authWithHeaders: AuthWithHeaders) => {
    const { headers } = authWithHeaders

    store.dispatch(Actions.headersSet({ headers }))
    store.dispatch(Actions.authSet({ auth: authWithHeaders }))
  },
  unsetAuthCookie: () => {
    store.dispatch(Actions.headersUnset())
    store.dispatch(Actions.authUnset())
  },
  setWorkspaces: (workspaces: RootState['workspace']['workspaces']) => {
    store.dispatch(Actions.workspacesSet(workspaces))
  },
  setCurrentWorkspaceId: (companyId: number) => {
    store.dispatch(Actions.currentWorkspaceIdSet(companyId))
  },
}
